export default "__VITE_ASSET__Ep0kKC2W__"